import React, { useState, useEffect } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonLoading } from '@ionic/react';
import { AxiosError } from 'axios';
import { useLocation } from 'react-router';

import { useActivateUser } from 'api/hooks/user/useActivateUser';

import { UserRegisterComplete } from 'components/user/UserRegisterComplete';
import { UserRegisterError } from 'components/user/UserRegisterError';

export const UserRegisterCompletePage: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { postActivate } = useActivateUser();
  const [presentLoading, dismissLoading] = useIonLoading();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const reqData = {
    id: searchParams.get('id') || '',
    activationCode: searchParams.get('activation_code') || '',
  };

  useEffect(() => {
    presentLoading({
      duration: 2000,
    });

    // ユーザーをアクティベートAPI コール
    postActivate(reqData)
      .catch((e: AxiosError<{ message: string; type: string }>) => {
        setErrorMessage(e.response?.data?.message || e.message);
      })
      .finally(() => {
        dismissLoading();
        setChecked(true);
      });
  }, []);

  if (!checked) return null;

  const isActivated = errorMessage?.includes('アクティベーション済みのコードです');
  const title = errorMessage ? (isActivated ? 'ユーザー登録済' : 'ユーザー登録失敗') : 'ユーザー登録完了';
  const conent = errorMessage ? (
    <UserRegisterError errorMessage={errorMessage} isActivated={isActivated} />
  ) : (
    <UserRegisterComplete />
  );

  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>{conent}</IonContent>
    </IonPage>
  );
};
